<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 36 36">
  <defs>
    <clipPath id="clip-Info">
      <rect width="36" height="36"/>
    </clipPath>
  </defs>
  <g id="Info" clip-path="url(#clip-Info)">
    <rect width="0" height="0" fill="#fff"/>
    <g id="Group_15024" data-name="Group 15024" transform="translate(4679 7762)">
      <g id="Ellipse_1049" data-name="Ellipse 1049" transform="translate(-4679 -7762)" fill="none" stroke="#5f686d" stroke-width="2">
        <circle cx="18" cy="18" r="18" stroke="none"/>
        <circle cx="18" cy="18" r="17.5" fill="none"/>
      </g>
      <circle id="Ellipse_1050" data-name="Ellipse 1050" cx="2" cy="2" r="2" transform="translate(-4663 -7751)" fill="#5f686d"/>
      <rect id="Rectangle_10039" data-name="Rectangle 10039" width="6" height="1.5" transform="translate(-4665 -7746)" fill="#ff0000"/>
      <rect id="Rectangle_10040" data-name="Rectangle 10040" width="4" height="7" transform="translate(-4663 -7745)" fill="#5f686d"/>
      <rect id="Rectangle_10041" data-name="Rectangle 10041" width="8" height="1.5" transform="translate(-4665 -7738.5)" fill="#5f686d"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
    name: "answerInfoIcon"
}
</script>




// WEBPACK FOOTER //
// src/common/components/svg/shared/answerInfoIcon.vue